import { IonLabel } from '@ionic/react';

import LoadingBg from '@/assets/imgs/loading/loading-bg.webp';
import PlaneLine from '@/assets/imgs/loading/plane-line.webp';
import PlaneShape from '@/assets/imgs/loading/plane-shape.webp';
import Stripe1 from '@/assets/imgs/loading/stripe-1.webp';
import Stripe2 from '@/assets/imgs/loading/stripe-2.webp';
import Stripe3 from '@/assets/imgs/loading/stripe-3.webp';
import Stripe4 from '@/assets/imgs/loading/stripe-4.webp';

import styles from './Transition.module.scss';

export default function Transition() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <IonLabel className={styles.titleModalLoading}>
          ¡Ya casi estamos!
        </IonLabel>
        <IonLabel className={styles.subtitle}>
          Solo quedan unos segundos.
        </IonLabel>
      </div>
      <div className={styles.planeContainer}>
        <img className={styles.planeBg} src={LoadingBg} alt="Process Finished" />
        <img className={styles.stripe1} src={Stripe1} alt="Process Finished" />
        <img className={styles.stripe2} src={Stripe2} alt="Process Finished" />
        <img className={styles.stripe3} src={Stripe3} alt="Process Finished" />
        <img className={styles.stripe4} src={Stripe4} alt="Process Finished" />
        <img className={styles.planeShape} src={PlaneShape} alt="Process Finished" />
        <img className={styles.planeLine} src={PlaneLine} alt="Process Finished" />
      </div>
    </div>
  );
}
